import { Pipe, PipeTransform } from '@angular/core';
  /*
    @author Mario S. Alves
    Pipe para normatizar links externos, sem http ou https para
    usar o protocolo http -> //${href}
  */
@Pipe({
  name: 'externalHref'
})
export class ExternalHrefPipe implements PipeTransform {

  transform(href: string): string {
    return /^(http:\/\/|https:\/\/)/.test(href) ? href : `//${href}`;
  }
}
